import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import './Progress.css'

export const Progress = () => {
    return (
        <div className='preprogress'>
            <CircularProgress />
        </div>
    )
}
